var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEx6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3194 41.3319L38.7037 38.9461C42.6541 34.9932 42.6541 28.5843 38.7037 24.6314C34.7533 20.6785 28.3483 20.6785 24.3979 24.6314L19.6293 29.403C15.6789 33.3559 15.6789 39.7648 19.6293 43.7177C21.4613 45.5508 23.8211 46.5338 26.2193 46.6667",
    stroke: "url(#paint0_linear_255_774)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6806 28.6681L31.2963 31.0539C27.3459 35.0068 27.3459 41.4157 31.2963 45.3686C35.2467 49.3215 41.6517 49.3215 45.6021 45.3686L50.3707 40.597C54.3211 36.6441 54.3211 30.2352 50.3707 26.2823C48.5387 24.4492 46.1789 23.4662 43.7807 23.3333",
    stroke: "url(#paint1_linear_255_774)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_774",
    x1: 29.1665,
    y1: 21.6667,
    x2: 29.1665,
    y2: 46.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_774",
    x1: 40.8335,
    y1: 23.3333,
    x2: 40.8335,
    y2: 48.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEx6);
export default __webpack_public_path__ + "static/media/ex6.335082d624728c5d18eddda10125c89e.svg";
export { ForwardRef as ReactComponent };